import { APICore } from './apiCore'

const api = new APICore()

function getInstanceInternalForms (params) {
  const baseUrl = '/instances-internal-forms'
  return api.get(baseUrl, params)
}

function getInstanceInternalForm (id) {
  const baseUrl = `/instances-internal-forms/${id}`
  return api.get(baseUrl, {})
}

function addInstanceInternalForm (params) {
  const baseUrl = '/instances-internal-forms'
  return api.createWithFile(baseUrl, params)
}

function updateInstanceInternalForm (params) {
  const baseUrl = '/instances-internal-forms'
  return api.updateWithFile(baseUrl, params)
}

function deleteInstanceInternalForm (params) {
  const baseUrl = '/instances-internal-forms'
  return api.delete(baseUrl, params)
}

export { getInstanceInternalForms, getInstanceInternalForm, addInstanceInternalForm, updateInstanceInternalForm, deleteInstanceInternalForm }
